export const getAuthToken = () => {
  return sessionStorage.getItem('token');
};

export const setAuthToken = token => {
  return sessionStorage.setItem('token', token);
};
